__turbopack_context__.v({
  "close": "MobileEventRow-module-scss-module__yRARTa__close",
  "content": "MobileEventRow-module-scss-module__yRARTa__content",
  "icon": "MobileEventRow-module-scss-module__yRARTa__icon",
  "info": "MobileEventRow-module-scss-module__yRARTa__info",
  "root": "MobileEventRow-module-scss-module__yRARTa__root",
  "success": "MobileEventRow-module-scss-module__yRARTa__success",
  "warning": "MobileEventRow-module-scss-module__yRARTa__warning",
});
